<script lang="ts">
import { defineComponent, PropType } from 'vue'
import InputForm from '@/components/form/InputForm.vue'
import { formDefaultProps } from '@/models/formPartial'

export default defineComponent({
  name: 'InputFormDepartmentAndPosition',

  components: {
    InputForm,
  },

  props: {
    ...formDefaultProps,

    departmentAndPosition: {
      type: Object as PropType<InputText>,
      required: true,
    },

    header: {
      type: String,
      default: '部署・役職正式名称',
    },

    placeholder: {
      type: String,
      default: '例：BizHint事業部',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'off',
    },
  },

  emits: ['update:departmentAndPosition', 'error'],
})
</script>

<template>
  <InputForm
    :model-value="departmentAndPosition.value"
    :namespace="namespace"
    :name="departmentAndPosition.name"
    :header="header"
    :placeholder="placeholder"
    :validation-scheme="departmentAndPosition.validationScheme"
    @update:model-value="$emit('update:departmentAndPosition', $event)"
    @error="$emit('error', $event)" />
</template>

